import { Component } from '@angular/core';

@Component({
  selector: 'mtm-delete-icon',
  templateUrl: './delete-icon.component.html',
  styleUrls: [],
  standalone: false,
})
export class DeleteIconComponent {}
